import { gql } from '@apollo/client';

const GET_TWO_COLUMS_IMAGE_BY_SLUG = gql`
  query GetSectionBySlug($slug: String!) {
    sectionsBy(slug: $slug) {
      twocolumnsimage {
        tituloTci
        imagenDerecha {
          node {
            mediaItemUrl
            slug
          }
        }
        imagenIzquierda {
          node {
            mediaItemUrl
            slug
          }
        }
      }
    }
  }
`;

export { GET_TWO_COLUMS_IMAGE_BY_SLUG }